$('.block-logo-slider-overlapped').each(function() {

	let opts = {
        allowTouchMove: false,
        autoplay: {
            delay: 0,
        },
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 48,
        speed: 2500,
	};

	const swiper = new Swiper($(this).find('.swiper')[0], opts);

});